import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/me/profile";

export const profile = {
    // ...example,
    get(data){
        return axios.get(`${url}`).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}`, data).then(result => result.data);
    },
    confirm(data){
        return axios.post(`${url}/confirm`, data).then(result => result.data);
    }
}
